import { useEffect, useRef } from 'react';

import env from 'env';

import auth from '../auth';

import { useAuthSession } from './authSession';
interface Props {
  children: any;
}
const AuthRedirect = ({ children }: Props) => {
  const session = useAuthSession();
  const startedRef = useRef(false);
  const isCallbackRoute = window.location.pathname === '/auth/callback';

  useEffect(() => {
    if (env.development) return;
    if (isCallbackRoute) return;
    if (session.status === 'logging-out') return;
    if (session.user) return;
    if (startedRef.current) return;

    startedRef.current = true;
    void auth.login();
  }, [session.user, isCallbackRoute]);

  if (isCallbackRoute) {
    return children;
  }

  if (session.status === 'logging-out') return null;

  if (env.development) {
    return children;
  }

  if (!session.user) {
    return <></>;
  }
  return children;
};

export default AuthRedirect;
